import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'
export default {
  async refreshProducts () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'ProductRefresh',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.recordList.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  deleteProduct (product) {
    return new Promise((resolve, reject) => {
      Axios.del(
        'Product',
        product,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  updateProduct (product) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Product',
        product,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  updateProducts (products) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Products',
        products,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  reApplyProduct (product) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Product/submit',
        product,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  addProduct (payload = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Product',
        payload,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            if (response.data.header.resultCode === code.reachProductLimit) {
              reject(response.data.header.resultCode)
            }
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  async createParentProduct (payload = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'ParentProductCreate',
        payload,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  postRequestProductDownload (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        'Product/download',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },

  updateProductDeleteFlag (params) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Product',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getShipping (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Product/get-shipping-estimated-fees',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  async getGroupProducts (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'ParentProductGroup',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.recordList.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  addProducts (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Products',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            if (response.data.header.resultCode === code.reachProductLimit) {
              resolve(response.data.records)
            }
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  async createParentProducts (params = []) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'ParentProductsCreate',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  async getLatestProducts (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Product/update-latest-products',
        params,
        response => {
          if (!response || !response.data) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getYamatoShipping () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Product/get-yamato-shipping',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  updateAmountReceived (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Products/amount-received',
        params,
        response => {
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getBanners (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Product/banner',
        params,
        response => {
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  downloadAmountReceivedTemplate (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        'Products/amount-received/template',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },

  updateAmountReceivedByCsv (params) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Products/amount-received',
        params,
        response => {
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getProductImages (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Product/get-image-name',
        params,
        response => {
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/productservice.js